import { DecoratedFormProps, FormErrors, InjectedFormProps, reduxForm } from 'redux-form';
import { FormError } from 'src/components/redux-form/FormError';
import React, { Dispatch } from 'react';
import { maxLength, Validators } from 'src/components/redux-form/utils/validators';

import classNames from 'classnames';
import { FieldInput } from 'src/components/redux-form/fields/FieldInput';
import { Link } from 'react-router-dom';
import Router from 'src/navigation/router';
import { routes } from 'src/navigation';
import styles from './assets/serviceType-form.module.scss';
import { faSave, faBan } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { push } from 'connected-react-router';
import { toast } from 'react-toastify';
import { asyncPersistServiceType } from 'src/store/actions/service-type-actions';
import { FieldMultiDropdown } from '../../../../../components/redux-form/fields/FieldMultiDropdown';

export interface ServiceTypeFormData {
    id: string | number;
    title: string;
    cpt: string;
    isEvaluation: boolean;
    //providers: { title: string; id: number | string }[];
}
interface ServiceTypeFormProps {
    //providers: { title: string; id: number | string }[];
}

type InjectedProps = InjectedFormProps<ServiceTypeFormData, ServiceTypeFormProps>;

const validators: Validators<ServiceTypeFormData> = {
    title: [maxLength({ max: 255 })],
    cpt: [maxLength({ max: 255 })],
};

const ServiceTypeForm: React.FunctionComponent<InjectedProps & ServiceTypeFormProps> = ({
    handleSubmit,
   // providers,
    error,
    dirty,
    submitting,
    initialValues,
}: InjectedProps & ServiceTypeFormProps) => {
    const isNew = !initialValues || !initialValues.id;

    return (
        <form onSubmit={handleSubmit} className={classNames(styles.form)}>
            <FormError error={error} />
            <FieldInput
                name="id"
                type="hidden"
                wrapperConfig={{
                    classes: {
                        inputWrapper: 'm-0',
                    },
                }}
            />
            <FieldInput
                name="title"
                type="text"
                validate={validators.title}
                wrapperConfig={{
                    label: 'Name',
                }}
            />
            <FieldInput
                name="cpt"
                type="text"
                validate={validators.cpt}
                wrapperConfig={{
                    label: 'CPT',
                }}
            />

            <FieldInput
                name="isEvaluation"
                type="hidden"
                wrapperConfig={{
                    label: '',
                    classes: {
                        inputWrapper: 'customCheckbox',
                    },
                }}
            />
            <div className={classNames(styles.actions)}>
                <button
                    type="submit"
                    className={classNames('btn', 'btn-success', 'mr-3')}
                    disabled={!dirty || submitting}
                >
                    <FontAwesomeIcon icon={faSave} /> {isNew ? 'Create' : 'Update'}
                </button>
                <Link className={classNames('btn', 'btn-danger')} to={Router.generate(routes.PROVIDERS_LIST)}>
                    <FontAwesomeIcon icon={faBan} /> Cancel
                </Link>
            </div>
        </form>
    );
};
export default reduxForm<ServiceTypeFormData, ServiceTypeFormProps>({
    form: 'service-type-form',
    enableReinitialize: true,
    validate(
        values: ServiceTypeFormData,
        props: DecoratedFormProps<ServiceTypeFormData, ServiceTypeFormProps, string>,
    ): FormErrors<ServiceTypeFormData, string> {
        const errors: FormErrors<ServiceTypeFormData, string> = {};
        return errors;
    },
    onSubmit: asyncPersistServiceType,
    onSubmitSuccess(
        result: any,
        dispatch: Dispatch<any>,
        props: DecoratedFormProps<ServiceTypeFormData, ServiceTypeFormProps, string>,
    ) {
        const isNew = !props.initialValues || !props.initialValues.id;

        toast.success(`Service was successfully ${isNew ? 'created' : 'updated'}.`);
        dispatch(push(Router.generate(routes.SERVICE_TYPES_LIST)));
    },
    onSubmitFail(errors: { _error: string }) {
        if (errors._error) {
            toast.error(errors._error);
        }
    },
})(ServiceTypeForm);
